import { IStoreState } from 'modules/types';

export const getNotification = (state: IStoreState) => state.notification.notifications;
export const fetchingNotification = (state: IStoreState) => state.notification.isFecthing;
export const getPrivateMsgNotification = (state: IStoreState) => state.notification.privateMsgNotification;
